"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var FlatButton = {
  styles: function styles(theme) {
    return {
      root: {
        borderRadius: 4,
        padding: [0, theme.spacing.base * 1.5],
        minWidth: theme.spacing.base * 10
      },
      ghost: {
        backgroundColor: "transparent",
        borderColor: theme.colors.baseContrast030,
        "&:disabled": {
          color: theme.colors.baseContrast040,
          "&& svg": {
            fill: theme.colors.baseContrast040
          }
        }
      }
    };
  }
};
var _default = exports.default = FlatButton;